import React, { useState, useEffect } from "react";
import { useStaticQuery, graphql } from "gatsby";
import Img from "gatsby-image";
import styles from "./style.module.scss";

export default function Banner() {
  const [pictureOffset, setPictureOffset] = useState(0);
  const [width, setWidth] = useState(null);

  const { poole, mtv, chance } = useStaticQuery(graphql`
    query {
      poole: contentfulAsset(contentful_id: { eq: "4ATHhgpGPV5hHxSKyIb1Bf" }) {
        fluid(maxHeight: 600) {
          ...GatsbyContentfulFluid_withWebp
        }
      }

      mtv: contentfulAsset(contentful_id: { eq: "2nVk1zKSLxPk9WQRlQrW94" }) {
        fluid(maxHeight: 600) {
          ...GatsbyContentfulFluid_withWebp
        }
      }

      chance: contentfulAsset(contentful_id: { eq: "43rWusOLw3bxQfuJQzMDex" }) {
        fluid(maxHeight: 600) {
          ...GatsbyContentfulFluid_withWebp
        }
      }
    }
  `);

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    setWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleScroll = () => {
    setPictureOffset(window.pageYOffset * 0.2);
  };

  const handleResize = () => {
    setWidth(window.innerWidth);
  };

  const imageCustomStyle = negative => {
    const translate = negative ? `-${pictureOffset}px` : `${pictureOffset}px`;
    if (width < 718) {
      return { transform: `translateX(${translate})` };
    }

    return { transform: `translateY(${translate})` };
  };

  return (
    <div className={styles.container}>
      <div className={styles.item}>
        <h1>The Apparel Gurus</h1>
        <p>
          Greek Dressing makes designing and ordering custom apparel for your
          organization easy. We know you may not be an expert graphic designer
          or screen-printing ninja, that's why our team does all of the heavy
          lifting for you!
        </p>
      </div>
      <div className={styles.item}>
        <div className={styles.image}>
          <Img
            fluid={poole.fluid}
            alt="Custom fraternity apparel"
            style={imageCustomStyle(true)}
          />
        </div>
        <div className={styles.image}>
          <Img fluid={mtv.fluid} alt="Custom sorority apparel" />
        </div>
        <div className={styles.image}>
          <Img
            fluid={chance.fluid}
            alt="Screen printing"
            style={imageCustomStyle()}
          />
        </div>
      </div>
    </div>
  );
}
